import { useBrand } from "../context/BrandContext";

function Section({ title, children }) {
    return (
        <section className="mb-10">
            <h2 className="font-display text-xl font-bold tracking-[-0.02em] mb-3">{title}</h2>
            <div className="space-y-3 text-sm leading-relaxed text-dim">{children}</div>
        </section>
    );
}

export default function PrivacyPage() {
    const brand = useBrand();
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="privacy-page">
            <div className="panel p-8 sm:p-10 mb-12">
                <span className="eyebrow text-accent">Legal</span>
                <h1 className="font-display text-3xl sm:text-5xl font-black uppercase tracking-[-0.035em] mt-2.5">Privacy Policy</h1>
                <p className="font-mono text-xs text-dim mt-4">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
            </div>

            <Section title="1. Introduction">
                <p>{brand.site_name} ("we", "us", "our") operates {brand.domain}. This policy explains what information we collect, how we use it, and the choices you have. We do not use analytics, tracking pixels, or session-recording technologies.</p>
            </Section>
            <Section title="2. Information We Collect">
                <p>When you create an account or join our mailing list, we collect your name, email address, country, and phone number. We record your consent choices for transactional and marketing communications.</p>
            </Section>
            <Section title="3. How We Use Your Information">
                <p>We use your contact details to send you the communications you have consented to — editorial newsletters, service notifications, and, where you opt in, marketing messages by email and SMS. We never sell your personal information.</p>
            </Section>
            <Section title="4. SMS Messaging">
                <p>If you provide your phone number and opt in, we may send you text messages. Consent is optional and is not a condition of any purchase. Message and data rates may apply. Message frequency varies, up to 4 messages per week.</p>
                <p>You can opt out of SMS at any time by replying STOP. Reply HELP for assistance. Mobile opt-in data and consent are never shared with third parties for their marketing purposes.</p>
            </Section>
            <Section title="5. Your Choices & Unsubscribing">
                <p>You may unsubscribe from email or SMS marketing at any time using the unsubscribe link in the footer of our site, the one-click unsubscribe link in any email we send, or by replying STOP to any SMS.</p>
            </Section>
            <Section title="6. Data Retention">
                <p>We retain your account and consent records for as long as your subscription is active. You may request deletion of your data by contacting us.</p>
            </Section>
            <Section title="7. No Tracking">
                <p>We do not embed third-party analytics, advertising trackers, or session-recording scripts. Your reading activity on this site is not profiled or sold.</p>
            </Section>
            <Section title="8. Contact">
                <p>Questions about this policy? Email us at {brand.support_email}.</p>
            </Section>
        </div>
    );
}
